import { render, staticRenderFns } from "./estadoDeCuenta.vue?vue&type=template&id=220ce503&scoped=true&"
import script from "./estadoDeCuenta.vue?vue&type=script&lang=js&"
export * from "./estadoDeCuenta.vue?vue&type=script&lang=js&"
import style0 from "./estadoDeCuenta.vue?vue&type=style&index=0&id=220ce503&lang=scss&scoped=true&"
import style1 from "./estadoDeCuenta.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ce503",
  null
  
)

export default component.exports